import React from "react";
import { alpha } from "@mui/material/styles";
import { tokens } from "@/theme/tokens";

export const TermsPageContainer = () => {
  return (
    <div
      className="termsPage"
      style={{
        padding: "32px",
        maxWidth: "800px",
        margin: "0 auto",
        backgroundColor: "#fafafa",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {/* Subtle background accent */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "200px",
          background: `linear-gradient(135deg, ${alpha(tokens.accent.main, 0.18)} 0%, ${alpha(tokens.accent.main, 0.06)} 100%)`,
          opacity: 0.03,
          zIndex: -1,
        }}
      ></div>
      <h1
        style={{
          color: "#333",
          fontSize: "42px",
          textAlign: "center",
          marginBottom: "40px",
          fontWeight: "600",
        }}
      >
        Terms and Conditions
      </h1>
      <p>Last updated: January 7, 2025</p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        1. Acceptance of Terms
      </h2>
      <p>
        By accessing and using Monthly ("the Service"), you accept and agree to
        be bound by the terms and provision of this agreement. If you do not
        agree to abide by the above, please do not use this service.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        2. Description of Service
      </h2>
      <p>
        Monthly is a personal finance management application that allows users
        to track expenses, create budgets, set savings goals, and monitor
        investments. The Service is provided free of charge and does not require
        any banking or financial account information.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        3. User Account
      </h2>
      <p>
        To use the Service, you must create an account using a valid email
        address. You are responsible for maintaining the confidentiality of your
        account credentials and for all activities that occur under your
        account.
      </p>
      <p>You agree to:</p>
      <ul>
        <li>
          Provide accurate and complete information when creating your account
        </li>
        <li>Maintain and promptly update your account information</li>
        <li>Notify us immediately of any unauthorized use of your account</li>
        <li>Be responsible for all activities that occur under your account</li>
      </ul>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        4. User Conduct
      </h2>
      <p>
        You agree to use the Service only for lawful purposes and in accordance
        with these Terms. You agree not to:
      </p>
      <ul>
        <li>
          Use the Service in any way that violates any applicable law or
          regulation
        </li>
        <li>
          Attempt to gain unauthorized access to the Service or its related
          systems
        </li>
        <li>
          Interfere with or disrupt the Service or servers or networks connected
          to the Service
        </li>
        <li>
          Use the Service to transmit any viruses, malware, or other harmful
          code
        </li>
        <li>
          Impersonate any person or entity or falsely state or misrepresent your
          affiliation with any person or entity
        </li>
      </ul>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        5. Privacy and Data Protection
      </h2>
      <p>
        Your use of the Service is also governed by our Privacy Policy. By using
        the Service, you consent to the collection and use of your information
        as described in the Privacy Policy.
      </p>
      <p>
        All financial data you enter into the Service (expenses, budgets,
        savings goals, investments) is stored securely and is accessible only to
        you. We do not share your financial data with third parties.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        6. Intellectual Property
      </h2>
      <p>
        The Service and its original content, features, and functionality are
        and will remain the exclusive property of Monthly and its licensors. The
        Service is protected by copyright, trademark, and other laws. Our
        trademarks and trade dress may not be used in connection with any
        product or service without our prior written consent.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        7. User Content
      </h2>
      <p>
        You retain ownership of all financial data and information you input
        into the Service ("User Content"). By using the Service, you grant us a
        limited license to use, store, and process your User Content solely for
        the purpose of providing the Service to you.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        8. Disclaimer of Warranties
      </h2>
      <p>
        THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY
        WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE
        SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
      </p>
      <p>
        Monthly is a financial tracking tool only and does not provide financial
        advice. Any financial decisions you make based on information from the
        Service are your sole responsibility.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        9. Limitation of Liability
      </h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, MONTHLY SHALL NOT BE LIABLE FOR
        ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
        OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR
        INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE
        LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        10. Account Termination
      </h2>
      <p>
        You may terminate your account at any time by using the "Delete Account"
        feature in your Profile settings. Upon termination, all your data will
        be permanently deleted from our systems.
      </p>
      <p>
        We reserve the right to terminate or suspend your account immediately,
        without prior notice or liability, for any reason whatsoever, including
        without limitation if you breach the Terms.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        11. Changes to Terms
      </h2>
      <p>
        We reserve the right to modify or replace these Terms at any time. If a
        revision is material, we will provide at least 30 days notice prior to
        any new terms taking effect.
      </p>
      <p>
        Your continued use of the Service after any changes to the Terms
        constitutes your acceptance of the new Terms.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        12. Governing Law
      </h2>
      <p>
        These Terms shall be governed and construed in accordance with the laws
        of Croatia, without regard to its conflict of law provisions. Any legal
        action or proceeding relating to your access to, or use of, the Service
        shall be instituted in a court in Croatia.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        13. Contact Information
      </h2>
      <p>
        If you have any questions about these Terms and Conditions, please
        contact us through the Service or at the contact information provided in
        our Privacy Policy.
      </p>

      <h2
        style={{
          color: "#555",
          fontSize: "26px",
          marginBottom: "16px",
          fontWeight: "500",
          borderBottom: `2px solid ${tokens.accent.main}`,
          paddingBottom: "8px",
          display: "inline-block",
        }}
      >
        14. Entire Agreement
      </h2>
      <p>
        These Terms, together with our Privacy Policy, constitute the entire
        agreement between you and Monthly regarding the use of the Service and
        supersede any prior agreements between you and Monthly relating to the
        Service.
      </p>
    </div>
  );
};
